import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import * as messageActions from 'automation-ui-canvas/actions/MessageActions';
import { DELETE_ACTION_SET } from 'automation-ui-canvas/components/action-set/ActionSetQueries';
import { ACTION_SET_DELETE_FAIL, ACTION_SET_DELETE_SUCCESS } from 'automation-ui-canvas/constants/AlertTypes';
import useRecentlyDeletedActionSetIds from 'automation-ui-canvas/hooks/actionSets/useDeletedActionSetIds';
import UserName from 'automation-ui-references/customer-data/UserName';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useMutation } from 'data-fetching-client';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useDispatch } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteActionSetModal = ({
  actionSetId,
  createdByUserId = '',
  name,
  onClose,
  onSuccess
}) => {
  const dispatch = useDispatch();
  const trackEvent = useTrackEvent();
  const {
    addDeletedActionSetId
  } = useRecentlyDeletedActionSetIds();
  const [deleteActionSet, {
    loading
  }] = useMutation(DELETE_ACTION_SET, {
    variables: {
      actionSetId
    },
    onCompleted: () => {
      addDeletedActionSetId(actionSetId);
      dispatch(messageActions.addAlert(ACTION_SET_DELETE_SUCCESS));
      onSuccess();
    },
    onError: () => {
      dispatch(messageActions.addAlert(ACTION_SET_DELETE_FAIL));
    }
  });
  return /*#__PURE__*/_jsx(ConfirmModal, {
    ConfirmButton: LoadingButton,
    confirmButtonProps: {
      loading
    },
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.actionSet.deleteModal.confirmLabel"
    }),
    confirmUse: "danger",
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.actionSet.deleteModal.description",
      options: {
        createdBy: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(UserName, {
            id: createdByUserId
          })
        }),
        name
      }
    }),
    message: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.actionSet.deleteModal.title",
      options: {
        name
      }
    }),
    onConfirm: () => {
      trackEvent(Trackables.CLICKED_DELETE_ACTION_SET);
      deleteActionSet().catch(error => {
        console.error(error);
      });
    },
    onReject: () => onClose(),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.actionSet.deleteModal.rejectLabel"
    }),
    use: "danger"
  });
};
export default DeleteActionSetModal;